// frontend/src/components/TreezIntegration.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const TreezIntegration = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  
  // Hardcoded client ID
  const HARDCODED_CLIENT_ID = 'wNzewkHXh2P5GnfCFPX3AmeA';
  
  const [credentials, setCredentials] = useState({
    dispensaryName: '',
    apiKey: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({
    connected: false,
    dispensaryName: '',
    lastSync: null
  });
  const [message, setMessage] = useState('');
  const [importStatus, setImportStatus] = useState(null);
  const [importLoading, setImportLoading] = useState(false);
  
  // Load initial status
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await api.get('/treez/status');
        console.log('Treez status response:', response.data);
        
        if (response.data.success) {
          setStatus({
            connected: response.data.connected,
            dispensaryName: response.data.dispensaryName || '',
            lastSync: response.data.lastSync
          });
        }
      } catch (error) {
        console.error('Error fetching Treez status:', error);
      }
    };
    
    fetchStatus();
  }, []);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    
    try {
      // Include the hardcoded client ID with the form data
      const credentialsWithClientId = {
        ...credentials,
        clientId: HARDCODED_CLIENT_ID
      };
      
      const response = await api.post('/treez/credentials', credentialsWithClientId);
      console.log('Credentials response:', response.data);
      
      if (response.data.success) {
        setStatus({
          connected: true,
          dispensaryName: response.data.data.dispensaryName,
          lastSync: null
        });
        setMessage('Successfully connected to Treez!');
      }
    } catch (error) {
      console.error('Connection error:', error);
      setMessage(error.response?.data?.message || 'Failed to connect to Treez');
    } finally {
      setLoading(false);
    }
  };
  
  const handleImportProducts = async () => {
    setImportLoading(true);
    setImportStatus(null);
    
    try {
      console.log('Importing products from Treez...');
      
      // Use the API client to import products
      const response = await api.post('/treez/import-products');
      console.log('Import products response:', response.data);
      
      if (response.data.success) {
        setImportStatus({
          success: true,
          message: response.data.message
        });
        // Update last sync time
        setStatus(prev => ({
          ...prev,
          lastSync: new Date()
        }));
      } else {
        setImportStatus({
          success: false,
          message: response.data.message || 'Failed to import products'
        });
      }
    } catch (error) {
      console.error('Import products error:', error);
      setImportStatus({
        success: false,
        message: error.response?.data?.message || 'Failed to import products'
      });
    } finally {
      setImportLoading(false);
    }
  };
  
  if (!auth) {
    return <p>Loading...</p>;
  }
  
  return (
    <div className="container mt-4">
      <h2>Treez POS Integration</h2>
      
      {status.connected ? (
        <div className="card mb-4">
          <div className="card-body">
            <h5 className="card-title">Connected to Treez</h5>
            <p className="card-text">
              <strong>Dispensary Name:</strong> {status.dispensaryName}
            </p>
            {status.lastSync && (
              <p className="card-text">
                <strong>Last Synced:</strong> {new Date(status.lastSync).toLocaleString()}
              </p>
            )}
            
            <button 
              className="btn btn-primary" 
              onClick={handleImportProducts}
              disabled={importLoading}
            >
              {importLoading ? 'Importing...' : 'Import Products'}
            </button>
            
            {importStatus && (
              <div className={`alert mt-3 ${importStatus.success ? 'alert-success' : 'alert-danger'}`}>
                {importStatus.message}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="card mb-4">
          <div className="card-body">
            <h5 className="card-title">Connect to Treez</h5>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="dispensaryName" className="form-label">Dispensary Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="dispensaryName"
                  name="dispensaryName"
                  value={credentials.dispensaryName}
                  onChange={handleInputChange}
                  required
                />
                <small className="text-muted">
                  As displayed in URL [Dispensaryname].treez.io. (e.g., 'thehigherpath')
                </small>
              </div>
              
              <div className="mb-3">
                <label htmlFor="apiKey" className="form-label">API Key</label>
                <input
                  type="password"
                  className="form-control"
                  id="apiKey"
                  name="apiKey"
                  value={credentials.apiKey}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Connecting...' : 'Connect'}
              </button>
              
              {message && (
                <div className={`alert mt-3 ${message.includes('Success') ? 'alert-success' : 'alert-danger'}`}>
                  {message}
                </div>
              )}
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TreezIntegration;